import http from '@/libs/AxiosPlugin'

const department = {
  list () {
    return http.get('/department/list')
  },

  delete (id) {
    return http.post('/department/delete', {id})
  },

  get (id) {
    return http.post('/department/get', {id})
  },

  save (r) {
    return http.post('/department/save', r)
  }
}

export default department



// WEBPACK FOOTER //
// ./src/api/department.js